import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router";
import { scheduleContentScroll } from "../utils/scroll/pageScroll";

export default function useNavigationScroll() {
  const { key, pathname, search, hash } = useLocation();

  useEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => { window.history.scrollRestoration = previous; };
  }, []);

  useLayoutEffect(() => {
    let target = null;
    if (hash) {
      try { target = document.getElementById(decodeURIComponent(hash.slice(1))); }
      catch { /* An invalid fragment should still allow the page to open. */ }
    }
    return scheduleContentScroll(target);
  }, [key, pathname, search, hash]);
}
